<template>
  <section
    class="w-[280px] overflow-hidden rounded-12 bg-elev-context-menu-bg shadow-overlay"
    data-test="message-reactions-viewer"
  >
    <div class="p-1">
      <button
        type="button"
        data-test="message-reactions-viewer-back"
        class="box-border flex h-9 w-full cursor-pointer items-center gap-1 rounded-8 px-2 text-body-r-14-20 text-fg-base-fg3 hover:bg-surf-neut-soft-hov"
        @click="emit('back')"
      >
        <wui-icon
          name="chevronLeftLgM"
          class="shrink-0"
        />
        <span>{{ $t('common.back') }}</span>
      </button>
    </div>
    <hr class="mx-2 border-t border-bor-nav">

    <ul class="flex max-h-[320px] flex-col gap-[14px] overflow-y-auto px-4 py-[11px]">
      <li
        v-for="item in items"
        :key="`${item.author}-${item.emoji}`"
      >
        <message-reaction-flyout-item
          :author="item.author"
          :emoji="item.emoji"
        />
      </li>
    </ul>
  </section>
</template>

<script setup lang="ts">
import { WuiIcon } from '@wui/common-library'
import { storeToRefs } from 'pinia'
import { computed } from 'vue'

import { useReactionsStore } from '@/entities/reaction'

import MessageReactionFlyoutItem from './message-reaction-flyout-item.vue'

const props = defineProps<{
  eventId: number
}>()

const emit = defineEmits<{
  (event: 'back'): void
}>()

const reactionsStore = useReactionsStore()
const { reactionEvents } = storeToRefs(reactionsStore)
const { getReactionListItems } = reactionsStore

const items = computed(() => {
  void reactionEvents.value.get(props.eventId)
  return getReactionListItems(props.eventId)
})
</script>
